module.exports = __webpack_public_path__ + "img/cardPlans.4af6a981.svg";